import { parseDomain, ParseResultType } from "parse-domain";

export const urlToURL = (url: string | undefined) => {
	if (url == null) {
		return;
	}
	try {
		return new URL(url);
	} catch {
		return;
	}
}

export const urlToDomain = (url: string | undefined) => urlToURL(url)?.hostname;
export const urlToOrigin = (url: string | undefined) => urlToURL(url)?.origin;

export const urlToProtocol = (url: string | undefined) => urlToURL(url)?.protocol;

export const getUrlWithoutQueryOrHash = (url: string | undefined) => {
	const urlObj = urlToURL(url);
	if (urlObj == null || urlObj.origin.length === 0) return;
	return `${urlObj.origin}${urlObj.pathname ?? ''}`;
}

export const removeHashFromUrl = (url: string) => url.split('#')[0] ?? "";

export const domainToSortOrderString = (domain: string) => domain.split('.').reverse().join('.');

const splitDomainCache = new Map<string, {subdomain: string, subdomainPrefix: string, registeredDomain: string}>();
export const splitDomain = (fullDomain: string) => {
	const cached = splitDomainCache.get(fullDomain);
	if (cached != null) return cached;
	const parseResult = parseDomain(fullDomain);
	if (parseResult.type !== ParseResultType.Listed) return {subdomain: '', subdomainPrefix: '', registeredDomain: fullDomain};
	const {subDomains, domain, topLevelDomains } = parseResult.icann;
	const subdomain = subDomains.join('.')
	const subdomainPrefix = subdomain + (subDomains.length > 0 ? '.' : '');
	const registeredDomain = (domain != null ? `${domain}.` : ``) + topLevelDomains.join('.');
	splitDomainCache.set(fullDomain, {subdomain, subdomainPrefix, registeredDomain});
	return {subdomain, subdomainPrefix, registeredDomain};
}

export const isOriginAUrl = (candidate: string) => candidate.indexOf('/') >= 0;

const getRegisteredDomainCache = new Map<string, string | undefined>();
export const getRegisteredDomain = (fullDomainOrUrl?: string) => {
	if (fullDomainOrUrl == null) return undefined;
	const url = isOriginAUrl(fullDomainOrUrl) ? urlToURL(fullDomainOrUrl) : undefined;
	if (url != null && url.protocol.includes(('extension'))) return undefined;
	const fullDomain = url?.hostname ?? fullDomainOrUrl;
	if (fullDomain == null || fullDomain === "" || fullDomain === "about:blank")  return undefined;
	if (fullDomain.indexOf('.') === -1) return undefined;
	return getRegisteredDomainCache.get(fullDomain) ?? (() => {
		try {
			const {registeredDomain} = splitDomain(fullDomain);
			getRegisteredDomainCache.set(fullDomain, registeredDomain);
			return registeredDomain;
		} catch {
			getRegisteredDomainCache.set(fullDomain, undefined);
			return;
		}
	})();
}

export const domainsShareBaseOrigin = (domain1?: string, domain2?: string): boolean => {
	return getRegisteredDomain(domain1) === getRegisteredDomain(domain2);
	// if (domain1 == null || domain2 == null) return false;
	// const parseResult = parseDomain(domain1);
	// if (parseResult.type !== ParseResultType.Listed) return false;
	// const { domain, topLevelDomains } = parseResult;
	// const baseDomain = '.' + [domain, ...topLevelDomains].join('.');
	// return domain2.endsWith(baseDomain);
}

export const urlsShareBaseOrigin = (url1?: string, url2?: string): boolean => {
	if (url1 == null || url2 == null) return false;
	const domain1 = urlToDomain(url1);
	const domain2 = urlToDomain(url2);
	return domainsShareBaseOrigin(domain1, domain2);
};
export const getDomain = (urlOrDomain: string | undefined): string | undefined => {
	if (urlOrDomain == null) return undefined;
	return isOriginAUrl(urlOrDomain) ? urlToDomain(urlOrDomain) : urlOrDomain;
};
